import $ from 'jquery';
import 'slick-carousel';

const TxtImgSlider = () => {
  const textImgCarousel = $('.text-img-slider-contain');

  textImgCarousel.slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: true,
    cssEase: 'linear',
    draggable: false,
    autoplay: false,
    speed: 800,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
        },
      },
    ],
  });

  // ticking machine
  let percentTime;
  let tick;
  const time = 1;
  let progressBarIndex = 0;

  $('.progressBarContainer .progressBar__bar').each(function (index) {
    const progress = `<div class='inProgress inProgress${index}'></div>`;
    $(this).html(progress);
  });

  function startProgressbar() {
    resetProgressbar();
    percentTime = 0;
    tick = setInterval(interval, 10);
  }

  function interval() {
    if (
      $(
        `.text-img-slider-contain .slick-track div[data-slick-index="${progressBarIndex}"]`
      ).attr('aria-hidden') === 'true'
    ) {
      progressBarIndex = $(
        '.text-img-slider-contain .slick-track div[aria-hidden="false"]'
      ).data('slickIndex');
      startProgressbar();
    } else {
      percentTime += 1 / (time + 5);
      $(`.inProgress${progressBarIndex}`).css({
        width: `${percentTime}%`,
      });
      if (percentTime >= 100) {
        $('.text-img-slider-contain').slick('slickNext');
        progressBarIndex++;
        if (progressBarIndex > 2) {
          progressBarIndex = 0;
        }
        startProgressbar();
      }
    }
  }

  function resetProgressbar() {
    $('.inProgress').css({
      width: `${0}%`,
    });
    clearInterval(tick);
  }
  startProgressbar();
  // End ticking machine

  $('.progressBarContainer .progressBar').click(function () {
    clearInterval(tick);
    const goToThisIndex = $(this).find('span').data('slickIndex');
    $('.text-img-slider-contain').slick('slickGoTo', goToThisIndex, false);
    startProgressbar();
  });
};

export default TxtImgSlider;
